export const API_URL = process.env.REACT_APP_API_URL;
export const NODE_ENV = process.env.NODE_ENV || "production";
export const CLIENT_TYPE = process.env.REACT_APP_CLIENT_TYPE || "back_office";
export const GOOGLE_MAPS_API_KEY = process.env.REACT_APP_GOOGLE_MAPS_API_KEY;
export const GOOGLE_MAPS_MAP_ID = process.env.REACT_APP_GOOGLE_MAPS_MAP_ID;
export const TIMEZONE = Intl.DateTimeFormat().resolvedOptions().timeZone || "UTC"; // Obtener zona horaria local
export const WS_BASE_URL = `${process.env.REACT_APP_WS_PROTOCOL}://${process.env.REACT_APP_HOST}/ws/`;
export const platforms = ["web", "mobile-app"];
export const userRequestType = ["reservation", "urgency"];
